export default __webpack_public_path__ + "static/img/pic2@2x.8ee129.png";